import { render, staticRenderFns } from "./my-contacts.vue?vue&type=template&id=e759ee02&scoped=true"
import script from "./my-contacts.vue?vue&type=script&lang=js"
export * from "./my-contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e759ee02",
  null
  
)

export default component.exports